import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { DropdownField } from 'shared/controls';
import { useCustomerTypes } from 'shared/queries';
import { Brands } from 'shared/types';

export function CustomerTypeDropdown() {
  const name = 'customer.customerType';
  const { brand } = useParams<{ brand: Brands }>();
  const {
    formState: { errors },
  } = useFormContext();

  const { types, isLoading, isFetching } = useCustomerTypes(brand);
  const loading = isLoading || isFetching;

  return (
    <DropdownField
      name={name}
      label='Customer Type'
      rules={{
        required: {
          message: 'Customer Type is Required',
          value: true,
        },
      }}
      error={Boolean(errors.customer?.customerType)}
      helperText={errors.customer?.customerType?.message}
      options={types || []}
      loading={loading}
    />
  );
}
